import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router";

import SideMenu from "./SideMenu";
import MobileMenu from "./MobileMenu";
import TrialLayoutBanner from "./TrialLayoutBanner";

import { DrawerProvider } from "contexts/DrawerContext";

import SuccessModal from "pages/Invoices/SuccessModal";
import TransparentFooter from "components/Footer/TransparentFooter";

import { useAppDispatch, useAppSelector } from "store/hooks";
import featureAnnouncementService from "services/featureAnnouncements";

import { ModalType, openModal } from "store/features/modalSlice";

import { ONBOARDING_MODAL_CONTENT } from "shared/constants/modalContent";

import "./index.scss";
import {
  setCreatedInvoiceUrl,
  setShowSuccessModal,
} from "store/features/ibanInvoiceSlice";

const MODAL_ANIMATION_DELAY = 300;

const CabinetLayout: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  const createdInvoiceUrl = useAppSelector(
    (state) => state.ibanInvoice.createdInvoiceUrl,
  );
  const showSuccessModal = useAppSelector(
    (state) => state.ibanInvoice.showSuccessModal,
  );

  const onCloseSuccessModal = () => {
    dispatch(setShowSuccessModal(false));
    setTimeout(() => {
      dispatch(setCreatedInvoiceUrl(null));
    }, MODAL_ANIMATION_DELAY);
  };

  useEffect(() => {
    const featureId = ONBOARDING_MODAL_CONTENT.featureId;

    if (
      featureId &&
      featureAnnouncementService().shouldShowReminder(featureId)
    ) {
      dispatch(openModal(ModalType.VIDEO, ONBOARDING_MODAL_CONTENT));
    }
  }, [location]);

  return (
    <DrawerProvider>
      <div className="cabinet-layout">
        <SideMenu />
        <div className="cabinet-content">
          <TrialLayoutBanner />
          <MobileMenu />
          <div className="cabinet-children">
            <Outlet />
          </div>
          <TransparentFooter withSocials />
        </div>
        <SuccessModal
          isOpen={showSuccessModal}
          onClose={onCloseSuccessModal}
          ibanInvoiceUrl={createdInvoiceUrl}
        />
      </div>
    </DrawerProvider>
  );
};

export default CabinetLayout;
